import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsTagsRoute extends Route {
  @service store;

  model() {
    return this.store.findAll('theme');
  }
}

export default instrumentRoutePerformance(SettingsTagsRoute);
